/**
 * BACKEND CONTRACT — the `forgotPassword` mutation emails the link we give it after swapping these
 * placeholders for the account's email and the reset token.
 */
export const PASSWORD_RESET_EMAIL_PLACEHOLDER = '__EMAIL__';

export const PASSWORD_RESET_TOKEN_PLACEHOLDER = '__TOKEN__';

export const PASSWORD_RESET_EMAIL_QUERY_PARAM = 'email';

export const PASSWORD_RESET_TOKEN_QUERY_PARAM = 'token';
